<template>
  <div>
    <div v-if="!display.smAndDown" class="radio-filter">
      <span class="radio-filter__title">Пол врача</span>
      <div class="radio-filter__group">
        <SmRadio
          v-for="item in items"
          :key="item.id"
          :label="item"
          :values="item"
          v-model="syncSelected"
        />
      </div>
    </div>
    <div @click="openHanlder" class="radio-filter-mobile" v-else>
      <div>
        <div class="radio-filter-mobile--title">Пол врача</div>
        <div class="radio-filter-mobile--value">
          <span v-if="syncSelected === 'Любой'">{{ syncSelected }}</span>
          <span v-else>Выбрано: {{ syncSelected }} </span>
        </div>
      </div>
      <div class="radio-filter-mobile--icons">
        <CloseRoundIcon
          v-if="syncSelected !== 'Любой'"
          :onClose="resetFilter"
        />
        <span v-if="syncSelected !== 'Любой'" class="devider"></span>
        <ArrowDownIcon :style="{ rotate: isOpen ? '180deg' : '' }" />
      </div>
    </div>
    <Transition name="fade">
      <div v-if="isOpen" class="radio-filter-mobile__modal">
        <div class="radio-filter-mobile__modal--header">
          <span>Пол врача</span>
          <div @click="closeHanler">
            <CloseBoldIcon />
          </div>
        </div>
        <div class="radio-filter-mobile__modal--body">
          <SmRadio
            v-for="item in items"
            :key="item.id"
            :label="item"
            :values="item"
            v-model="syncSelected"
          />
        </div>
        <div class="radio-filter-mobile__modal--footer">
          <SmButton :onClick="applyHandler">Применить</SmButton>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>
import { useDisplay } from '@/hooks'
import { ref, toRefs } from '@vue/composition-api'

import SmRadio from '@/components/radio'
import SmButton from '@/components/button'
import ArrowDownIcon from '@/assets/icons/arrow-down'
import CloseBoldIcon from '@/assets/icons/close-bold'
import CloseRoundIcon from '@/assets/icons/close-round'

export default {
  name: 'radio-filter',
  components: {
    ArrowDownIcon,
    CloseBoldIcon,
    CloseRoundIcon,
    SmRadio,
    SmButton
  },
  props: ['items', 'value'],
  computed: {
    syncSelected: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  setup(props, ctx) {
    const { value } = toRefs(props)
    const display = useDisplay()

    const isOpen = ref(false)
    let stashSelected = null

    function openHanlder() {
      if (isOpen.value) {
        if (JSON.stringify(stashSelected) !== JSON.stringify(value.value)) {
          ctx.emit('input', stashSelected)
        }
      }

      stashSelected = value.value
      isOpen.value = !isOpen.value
    }

    function closeHanler() {
      if (!isOpen.value) return
      if (JSON.stringify(stashSelected) !== JSON.stringify(value.value)) {
        ctx.emit('input', stashSelected)
      }

      isOpen.value = false
    }

    function applyHandler() {
      this.$emit('submit', value.value)
      isOpen.value = false
    }

    function resetFilter() {
      this.$emit('input', 'Любой')
      this.$emit('submit', 'Любой')
    }

    return {
      display,
      isOpen,
      openHanlder,
      closeHanler,
      applyHandler,
      resetFilter
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
